module.exports = __webpack_public_path__ + "static/media/local-partners.d3cd43b5.svg";